export const GtmVariablesEnum = {
    // Service Template
    SERVICE_TEMPLATE_ID: 'stId',
    SERVICE_TEMPLATE_NAME_FR: 'stDescriptionFr',

    // Establishment Service Template
    ESTABLISHMENT_SERVICE_TEMPLATE_ID: 'estId',
    ESTABLISHMENT_SERVICE_TEMPLATE_NAME_FR: 'estNameFr',
    ESTABLISHMENT_SERVICE_TEMPLATE_PRICING_ENABLED: 'estPricingEnabled',

    // Establishment
    ESTABLISHMENT_ID: 'establishmentId',
    ESTABLISHMENT_TYPE: 'establishmentType',
    ESTABLISHMENT_NAME: 'establishmentName',

    // Head Office
    HEAD_OFFICE_REGION_CODE: 'headOfficeRegionCode',

    // Place
    PLACE_NAME: 'placeName',
    PLACE_POSTAL_CODE: 'placePostalCode',
    DISTANCE: 'distance',
    PLACE_REGION: 'placeRegion',

    // Appointment
    APPOINTMENT_NUMBER: 'apptNumber',
    APPOINTMENT_ID: 'apptId',
    APPOINTMENT_DATE_TIME: 'apptDateTime',
    APPOINTMENT_DATE: 'apptDate',
    NB_OF_DAYS_BEFORE_APPT: 'nbOfDaysBeforeAppt',

    // Settings
    IS_DATA_COLLECTION_ENABLED: 'isDataCollectionEnabled',

    // Patient data
    IS_FILTER_ADMISSIBLE: 'isAdmissible',
    IS_DATA_COLLECTION_FORM_COMPLETED: 'isDataCollectionFormCompleted',
    IS_DATA_COLLECTION_FORM_TOKEN_TIMEOUT: 'isDataCollectionFormTokenTimeout',
};
